export type InstallPlatform = 'ios' | 'android' | 'desktop' | 'generic'

// Detects the client platform for targeted PWA install instructions.
// Pure + arg-defaulted so unit tests can pass literal values directly.
export function detectPlatform(
  userAgent: string = navigator.userAgent,
  platform: string = navigator.platform ?? '',
  maxTouchPoints: number = navigator.maxTouchPoints ?? 0,
): InstallPlatform {
  // iPadOS 13+ reports as desktop Safari ("MacIntel"); the touch points give it away.
  const isIPadOS = platform === 'MacIntel' && maxTouchPoints > 1
  if (/iPad|iPhone|iPod/i.test(userAgent) || isIPadOS) return 'ios'
  if (/Android/i.test(userAgent)) return 'android'
  if (/Windows NT|Macintosh|Mac OS X|CrOS|Linux/i.test(userAgent)) return 'desktop'
  return 'generic'
}
